// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__V2vRY","api3DaoLogo":"navigation_api3DaoLogo__ubvgb","right":"navigation_right__qIh+l"};